import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import { USERNAME_REGEX } from '../../../constants/settings';
import { returnQueryConfig } from '../../../utils/commonFunctions';

const useCheckActions = (username: string) => {
  const getCheckAndSuggestUsername = useQuery({
    queryKey: ['check-and-suggest-username', username],
    queryFn: async () => {
      try {
        const response = await getPrivateAxiosInstance('user').get(
          `/check/and/suggest/${username}/`
        );

        if (response.status === 200) {
          return { message: 'Available', data: null };
        }

        return { message: 'Invalid', data: null };
      } catch (error) {
        if (
          (error as AxiosError<{ data: Array<string> }>).response?.status ===
          404
        ) {
          return { message: 'Invalid', data: null };
        }

        return {
          message: 'Already Taken',
          data: (error as AxiosError<{ data: Array<string> }>).response?.data
            .data as Array<string>,
        };
      }
    },

    ...returnQueryConfig(USERNAME_REGEX.test(username)),
  });

  return { getCheckAndSuggestUsername };
};

export default useCheckActions;
